import { STORAGE2_BASE_ID } from './storagetwo/storage2ComponentIDs';
import { getDuplicatedValues } from './utils/getDuplicatedValues';
// Note: it would be nicer to move over to the way STORAGE2_COMPONENT_NAMES are handled
//. but in case there are direct references to these numbers in some way (which there should not be)
//. it will be deferred for the future
const STORAGE1_COMPONENT_IDS = {
    BestaFrameComponent: 2001,
    BestaFrameLegsSystemComponent: 2002,
    BestaFrameLegsSystemSelectedLegComponent: 2003,
    BestaOpeningFunctionComponent: 2004,
    CollisionComponent: 2005,
    ConflictComponent: 2006,
    RangeComponent: 2008,
    InvalidPlacementComponent: 2009,
    OngoingAssemblyUpdateComponent: 2010,
    PlannerProductComponent: 2011,
    ProductInfoComponent: 2012,
    InvalidPlacedInteriorComponent: 2013,
    SelectedLegHeightComponent: 2014,
    ShoppingBagComponent: 2015,
    ViewerRoomComponent: 2016,
    CornerSolutionComponent: 2017,
    SeeThroughFrontComponent: 2018,
    DoorOpeningDirectionComponent: 2019,
    CustomizedSlidingDoorComponent: 2020,
    IgnoreHighlightComponent: 2021,
    StabilityComponent: 2023,
    SelectionOverrideComponent: 2024,
    ReplacedFrameComponent: 2025,
    InteriorComponent: 2026,
    SlidingDoorComponent: 2027,
    OuterMeasurementsComponent: 2028,
    CameraBehaviorComponent: 2029,
    CornerSolutionShelfReplacementComponent: 2030,
    MultiwallRoomComponent: 2031,
    EventComponent: 2033,
    HideDrawerFrontComponent: 2034,
    CustomSlidingDoorComponent: 2035,
    AllowedHandleTypeComponent: 2036,
    FrontLayoutComponent: 2037,
    HideFromAssemblyInstructionsComponent: 2038,
    DoorsNextToCornerSolutionComponent: 2039,
    CompartmentComponent: 2043,
    FrameTopComponent: 2044,
    NotSupportLeg: 2045,
    SelectedLegComponent: 2046,
    AgeGroupComponent: 2047,
    PlatsaFrontComponent: 2048,
    HelpLinesBoxColliderComponent: 2050,
    HelpLinesColliderComponent: 2051,
    PlatsaUncoupledSlidingDoorComponent: 2052,
    OrganizerComponent: 2053,
    DontAllowPlacementOnCornerAddonFrameComponent: 2054,
    MatchesColorsComponent: 2055,
    HelpLinesOuterMeasurementsComponent: 2056,
    HelpLinesOuterMeasurementsLineCenterComponent: 2057,
    MetalInteriorComponent: 2058,
    TopPanelComponent: 2059,
    MultiHandleComponent: 2060,
    CornerAddonFrameComponent: 2061,
    TVComponent: 2062,
    HideFromVpcImagesComponent: 2063,
    EntityColorComponent: 2064,
    SuspensionRailsComponent: 2065,
    RedOutlineComponent: 2066,
    LightSourceMetaComponent: 2067,
    ToggleDoorsComponent: 2068,
    AssemblyInstructionsComponent: 2069,
    IvarShadowBoxComponent: 2070,
    HideInSeeThroughSystemComponent: 2072,
    PlatsaUseSoftClosingHingesComponent: 2073,
    HelpLinesComponentShape: 2074,
    HelpLinesComponentVisible: 2075,
    HelpLinesComponentEditMode: 2076,
    ScreenshotComponent: 2077,
    IncludedProductComponent: 2078,
    FadeMaterialCustomComponent: 2079,
    MeasurementsLabelComponent: 2083,
    NonBehaviorDeleteComponent: 2084,
    CornerRegularFrameComponent: 2085,
    DontAllowPlacementOnCornerRegularFrameComponent: 2086,
    CompartmentModelComponent: 2087,
    RotatableComponent: 2088,
    AutofillSingleWallComponent: 2089,
    AutofillCornerComponent: 2090,
    LoftBedComponent: 2091,
    AddonComponent: 2092,
    DistanceMeasurementComponent: 2093,
    DistanceLineCenterComponent: 2094,
    NonDeletableComponent: 2095,
    EkrisComponent: 2096,
    NonDuplicableComponent: 2097,
    RequestUprightsComponent: 2098,
    RoomChangeComponent: 2099,
    InfoActionTargetComponent: 2101,
    ProhibitAdjustableComponent: 2102,
    ShelfBeingReplacedComponent: 2103,
    InvisibleEntityReferenceComponent: 2104,
    RoomChangeCompleteComponent: 3000,
    SettingsComponent: 3001,
    AngledEntityComponent: 3002,
    AdjustableClothrailLimitsComponent: 3003,
    AdjustableStateComponent: 3004,
    SnapshottableRequireSizeAdjustmentComponent: 3005,
    AdjustableComponent: 3006,
    AdjustableHostComponent: 3007,
    HelpLinesColliderBoxesComponent: 3008,
    RequireSizeWallAdjustmentComponent: 3009,
    NonProductInfoComponent: 3010,
    InteractiveEntityComponent: 3011,
    MoveableWorktopComponent: 3013,
    AddableComponent: 3014,
    AnimationComponent: 3015,
    AnimationStateComponent: 3016,
    WarningRuleComponent: 3017,
    WarningViolationsComponent: 3018,
    EketTipOverHazardComponent: 3019,
    StackableComponent: 3020,
    WarningLineComponent: 3125,
    WarningLineLabelComponent: 3126,
    DistanceMeasurementSuppressionComponent: 3136,
    HideFromKitchenDrawingsLegendComponent: 3137,
    KitchenDrawingsMeasurementComponent: 3138,
    KitchenDrawingsComponent: 3139,
    DistanceMeasurementMoveComponent: 3140,
    GhostSuggestionComponent: 3200
};
// Help avoid validation issues
const componentIdValues = Object.values(STORAGE1_COMPONENT_IDS);
const duplicatedComponentIds = getDuplicatedValues(componentIdValues);
if (duplicatedComponentIds.length) {
    throw new Error(`Duplicate values in STORAGE1_COMPONENT_IDS are not allowed. The following component ids appear multiple times: ${duplicatedComponentIds.join(', ')}`);
}
const MIN_ALLOWED_STORAGE1_COMPONENT_ID = 2000;
const MAX_ALLOWED_STORAGE1_COMPONENT_ID = STORAGE2_BASE_ID - 1;
const minComponentId = Math.min(...componentIdValues);
const maxComponentId = Math.max(...componentIdValues);
if (minComponentId < MIN_ALLOWED_STORAGE1_COMPONENT_ID) {
    throw new Error(`Component IDs for STORAGE1_COMPONENT_IDS should be >= ${MIN_ALLOWED_STORAGE1_COMPONENT_ID}`);
}
if (maxComponentId > MAX_ALLOWED_STORAGE1_COMPONENT_ID) {
    throw new Error(`Component IDs for STORAGE1_COMPONENT_IDS should be < ${MAX_ALLOWED_STORAGE1_COMPONENT_ID}`);
}
export const STORAGE_COMPONENT_IDS = {
    ...STORAGE1_COMPONENT_IDS
    // ...STORAGE2_COMPONENT_IDS // before we merge we need to normalize casing and also verify there are no duplicates
};
//# sourceMappingURL=componentIds.js.map